import { IsEnum, IsNumber, IsOptional, MinLength } from 'class-validator';

import { AuctionTypeEnum } from '@onArte/shared/enums/common/auctions';
import { OrderStatusEnum } from '@onArte/shared/enums/common/orders';
import { ListQuery } from '@onArte/shared/models/common';

export class OrderListQuery extends ListQuery {
  @IsOptional()
  @MinLength(1)
  public search?: string;

  @IsOptional()
  @IsNumber()
  public orderedAtFrom?: number;

  @IsOptional()
  @IsNumber()
  public orderedAtTo?: number;

  @IsOptional()
  @IsNumber()
  public finalPriceFrom?: number;

  @IsOptional()
  @IsNumber()
  public finalPriceTo?: number;

  @IsOptional()
  @IsNumber()
  public auctionCountFrom?: number;

  @IsOptional()
  @IsNumber()
  public auctionCountTo?: number;

  @IsOptional()
  @IsEnum(OrderStatusEnum)
  public status?: OrderStatusEnum;

  @IsOptional()
  @IsEnum(AuctionTypeEnum)
  public auctionType?: AuctionTypeEnum;

  constructor(
    limit?: number,
    offset?: number,
    search?: string,
    orderedAtFrom?: number,
    orderedAtTo?: number,
    finalPriceFrom?: number,
    finalPriceTo?: number,
    auctionCountFrom?: number,
    auctionCountTo?: number,
    status?: OrderStatusEnum,
    auctionType?: AuctionTypeEnum,
  ) {
    super(limit, offset);

    this.search = search;
    this.orderedAtFrom = orderedAtFrom;
    this.orderedAtTo = orderedAtTo;
    this.finalPriceFrom = finalPriceFrom;
    this.finalPriceTo = finalPriceTo;
    this.auctionCountFrom = auctionCountFrom;
    this.auctionCountTo = auctionCountTo;
    this.status = status;
    this.auctionType = auctionType;
  }
}
